export default "__VITE_ASSET__3bb4ef20__"